/**
 * Shared employee-status helpers (TPP-34 · AC-11).
 *
 * A "former" teammate is one who has left — `terminated` or `inactive`. We do
 * NOT treat `hired` as former: that status means a future/pre-boarding start,
 * i.e. an upcoming teammate, not a departed one. (`status !== 'active'` in the
 * acceptance criteria is shorthand for "the departed statuses"; flagging a
 * pending hire as "Former" would be wrong.)
 */
const FORMER_STATUSES = new Set(['terminated', 'inactive']);

/** True when the employee has left (terminated/inactive), for the "former" marker. */
export function isFormerEmployee(status?: string | null): boolean {
  return typeof status === 'string' && FORMER_STATUSES.has(status.trim().toLowerCase());
}

/** The subtle marker label shown next to a former teammate's name. */
export const FORMER_EMPLOYEE_LABEL = 'Former';

/**
 * Muted avatar treatment for a former teammate (TPP-34 · AC-11) — desaturated
 * and dimmed. Theme-independent (safe in light + dark). Shared so the avatar
 * surfaces (list team cell, avatar stack, team-overview grid) stay in lockstep.
 */
export const FORMER_AVATAR_SX = { filter: 'grayscale(1)', opacity: 0.55 } as const;
